import { makeStyles, shorthands } from '@fluentui/react-components';

export const useBackgroundRemovalModalStyle = makeStyles({
  uploadContainer: {
    position: 'relative',
  },
  contentArea: {
    height: '470px',
    overflowY: 'auto',
    scrollbarWidth: 'none',
  },
  chooseImageContainer: {
    ...shorthands.border('1px', 'dashed', '#D1D1D1'),
    ...shorthands.borderRadius('8px'),
    ...shorthands.padding('16px', '0px', '24px'),
    cursor: 'pointer',
    width: '100%',
    height: '240px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
  uploadIcon: {
    display: 'block',
    width: '128px',
    height: '128px',
    ...shorthands.margin('0px', 'auto', '4px'),
  },
  uploadTitle: {
    fontSize: '16px',
    lineHeight: '22px',
    color: '#1A1A1A',
    textAlign: 'center',
  },
  browse: {
    fontStyle: 'normal',
    marginLeft: '12px',
    color: '#115EA3',
  },
  uploadSubtext: {
    position: 'absolute',
    bottom: '24px',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#6C6C6C',
    textAlign: 'center',
    marginTop: '2px',
  },
  uploadButton: {
    position: 'absolute',
    width: '0px',
  },
  gridContainer: {
    marginTop: '12px',
  },
  gridTitle: {
    lineHeight: '20px',
    fontSize: '14px',
    fontWeight: '600',
    color: 'rgba(36, 36, 36, 1)',
  },
  loadingMask: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    ...shorthands.margin('auto'),
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: '1',
  },
  helpLink: {
    color: '#337ab7',
    ...shorthands.textDecoration('underline'),
    fontWeight: 'normal',
    backgroundColor: 'transparent',
    ...shorthands.borderRadius('0px', '0px', '0px', '0px'),
    ...shorthands.border('none'),
    width: '550px',
    display: 'block',
    textAlign: 'center',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  alertError: {
    marginTop: '10px',
  },
});

